import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { FormField } from '../../../../../utils/FormFields';

function PersonalReferencesTab({
  account, changedAccount, showChanges,
}) {
  const editPersonalReference = changedAccount.PersonalReferences[0];
  let comparePersonalReference;
  account.PersonalReferences.map((r) => {
    if (parseInt(r.AccountPersonalReferenceId, 10)
      === parseInt(editPersonalReference.AccountPersonalReferenceId, 10)) {
      comparePersonalReference = r;
    }
    return {};
  });
  let color = 'black';
  if (showChanges && editPersonalReference.AccountPersonalReferenceId > 0) {
    color = 'red';
  } else if (showChanges && parseInt(editPersonalReference.AccountPersonalReferenceId, 10) === 0) {
    color = 'green';
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges ? (
          <React.Fragment>
            {editPersonalReference.AccountPersonalReferenceId > 0
              ? 'Delete Personal Refernce'
              : 'New Personal Reference'}
          </React.Fragment>
        )
          : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {parseInt(editPersonalReference.AccountPersonalReferenceId, 10) === 0
              && <FormToShow reference={editPersonalReference} />}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {comparePersonalReference && <FormToShow reference={comparePersonalReference} />}
          </FormGroup>
        )}
    </Form>
  );
}

PersonalReferencesTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default PersonalReferencesTab;

const FormToShow = ({ reference }) => (
  <React.Fragment>
    {reference.AccountPersonalReferenceId > 0 && (
      <FormField
        name="AccountPersonalReferenceId"
        value={reference.AccountPersonalReferenceId}
        label="Id"
      />
    )}
    <FormField
      name="AccountPersonalReferenceName"
      value={reference.AccountPersonalReferenceName}
      label="Name"
    />
    <FormField
      name="AccountPersonalReferencePhone"
      value={reference.AccountPersonalReferencePhone}
      label="Phone"
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  reference: PropTypes.object.isRequired,
};
